var React = require('react');

function NavigationArrowWhite (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#fff","fillRule":"evenodd","opacity":".5"},[React.createElement("path",{"d":"M21 12.92a1 1 0 0 1-.71-.3L11 3.33l-9.29 9.29a1 1 0 1 1-1.42-1.41l10-10a1 1 0 0 1 1.42 0l10 10a1 1 0 0 1-.71 1.71z","key":0}),React.createElement("path",{"d":"M11 30a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v26a1 1 0 0 1-1 1z","key":1})]));
}

NavigationArrowWhite.defaultProps = {"viewBox":"0 0 22 30"};

module.exports = NavigationArrowWhite;

NavigationArrowWhite.default = NavigationArrowWhite;
